// extracted by mini-css-extract-plugin
export default {"container":"S01_Marquee_container__ZIVJy","wrapper":"S01_Marquee_wrapper__o6Uo6","marquee":"S01_Marquee_marquee__ghXwT","track":"S01_Marquee_track__bQz0B"};